import { observer } from 'mobx-react';
import { MultiSelect, MultiSelectChangeParams } from 'primereact/multiselect';
import { InputText } from 'primereact/inputtext';
import { Dispatch, FC, FormEvent, SetStateAction } from 'react';
import accountsStore from 'store/AccountsStore';
import commonStore from 'store/CommonStore';
import { AccountsFilters } from 'types';
import { getAccountRoleInRussian } from 'utils/functions';

type Props = {
  filters: AccountsFilters;
  setFilters: Dispatch<SetStateAction<AccountsFilters>>;
  setRows: Dispatch<SetStateAction<number>>;
  setCurrentPage: Dispatch<SetStateAction<number>>;
};

const UsersFilters: FC<Props> = ({
  filters,
  setFilters,
  setRows,
  setCurrentPage,
}) => {
  const handleInputLogin = (event: FormEvent<EventTarget>) => {
    const email = (event.target as HTMLInputElement).value;
    accountsStore.fetchAccounts({
      page: 1,
      size: 10,
      ...filters,
      emailPatterns: email,
    });
    setFilters({
      ...filters,
      emailPatterns: email,
    });
    setFirstPage();
  };

  const handleChangeRole = (event: MultiSelectChangeParams) => {
    const roles = event.value;
    accountsStore.fetchAccounts({
      page: 1,
      size: 10,
      ...filters,
      roles,
    });
    setFilters({
      ...filters,
      roles,
    });
    setFirstPage();
  };

  const setFirstPage = () => {
    setRows(1);
    setCurrentPage(0);
  };

  const roleDropdownOptions = commonStore.roles
    ? commonStore.roles.map((role) => ({
        label: getAccountRoleInRussian(role),
        value: role,
      }))
    : [];

  return (
    <div className="flex flex-wrap gap-3 mb-3">
      <InputText
        placeholder="Email"
        onInput={handleInputLogin}
        maxLength={254}
      />
      <MultiSelect
        placeholder="Роли"
        display="chip"
        options={roleDropdownOptions}
        onChange={handleChangeRole}
        value={filters.roles}
      />
    </div>
  );
};

export default observer(UsersFilters);
